module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_3-e7329fc79f867c279c0486c1bdcac08c.jpg";